import React from 'react'
import { useStyles } from './SubscriptionPaymentSchedule.styles'
import { TableComponentV2 } from '@labrav/react-components'
import { Typography, Grid } from '@mui/material'
import { PaymentSchedule } from '../../../../modules/subscription/reducer'
import { dateAndTimeConversion } from '../../../../common/utils/dateAndTimeConversion'
import { useSelector } from '../../../../store'
import { isNonEmptyNumber } from '@labrav/common'

export const SubscriptionPaymentSchedule = (props: {
  paymentschedules: PaymentSchedule[]
}) => {
  const { classes } = useStyles()
  const { paymentschedules } = props
  const paymentScheduleMapping = {
    Amount: 'amount',
    Date: 'paymentDate',
  }

  const timeZone = useSelector<string>(
    state =>
      state.userProfile.userProfile.timeZone ||
      state.userProfile.userProfile.defaultTimeZone ||
      'UTC'
  )

  const PaymentScheduleObject = paymentschedules.map(paymentDetail => ({
    amount: (
      <Typography className={classes.value}>
        {isNonEmptyNumber(paymentDetail.amount)
          ? `$${paymentDetail.amount}`
          : '-'}
      </Typography>
    ),
    paymentDate: (
      <Typography className={classes.value}>
        {paymentDetail.paymentDate
          ? dateAndTimeConversion(paymentDetail.paymentDate, timeZone)
              .modifiedDate
          : '-'}
      </Typography>
    ),
  }))
  return (
    <div className={classes.root}>
      <span className={classes.heading}>Payment schedule</span>
      <div className={classes.gridDiv}>
        <Grid
          container
          spacing={0}
          className={classes.tableGridComponent}
          width={'100%'}
        >
          <div className={classes.firstInnerDiv}>
            <TableComponentV2
              keyName={'paymentScheduleData'}
              objects={PaymentScheduleObject}
              mapping={paymentScheduleMapping}
              selectedItem={[]}
              onChangeCheckbox={() => void 0}
              showCheckbox={false}
              isBasicTable={true}
              count={0}
              fetchMoreData={() => void 0}
            />
          </div>
        </Grid>
      </div>
    </div>
  )
}
